import { useMutation } from '@tanstack/react-query'
import { postChurnDataAPI } from '../lib/api/api'

export let usePostChurnDataMutation = () => useMutation({
  mutationFn: async (data) => {
    await postChurnDataAPI(data)
  },
})
